import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, REQUEST, inject } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';

// Implementation from: https://github.com/KoderLabs/ngx-device-detector

@Injectable()
export class UniversalDeviceDetectorService extends DeviceDetectorService {
  constructor() {
    const platformId = inject(PLATFORM_ID);
    const request = inject(REQUEST, { optional: true });

    super();
    if (isPlatformServer(platformId) && request) {
      const userAgent = request.headers.get('user-agent');
      super.setDeviceInfo(userAgent || '');
    }
  }
}
